<template>
    <div class="v-loader">
        <span :style="`height: ${size}px; width: ${size}px; border-width: ${border}px;`" class="v-loader__animation"></span>
    </div>
</template>

<script>
export default {
    props: {
        size: {
            type: String,
            required: true
        },
        border: {
            type: String,
            required: true
        }
    }
}
</script>


<style lang="scss">
.v-loader {
    display: flex;
    align-items: center;
    justify-content: center;

    &__animation {
        width: 40px;
        height: 40px;
        border-style: solid;
        border-color: #c9d700 #ffffff #ffffff #ffffff;
        border-radius: 50%;
        animation: loader 1s infinite linear;
        box-shadow: 0 0 4px 0 rgba(#000000, 0.2), inset 0 0 4px 0 rgba(#000000, 0.2);
    }
}

@keyframes loader {
    from {
        transform: rotate(0deg);
    }
    to {
        transform: rotate(360deg);
    }
}
</style>

